<template>
    <div>
        <dialog-header v-if="showImage" :image="image" :title="showTitle ? course.name : ''" :show-close="showClose" @close="$emit('close')">
            <template #pretitle>
                <booking-status :space="course.space" :space-left="course.spaceLeft" :first-booking-time="course.firstBookingTime" :last-booking-time="course.lastBookingTime" size="22px" :text="true" />
            </template>
        </dialog-header>

        <h1 v-else-if="showTitle">{{course.name}}</h1>

        <div class="text--secondary" :class="textClass">
            <v-row no-gutters>
                <v-col cols=6 v-if="course.occasions">
                    <div>
                        <v-icon small color="primary" class="mr-1">mdi-calendar-check</v-icon>{{occasionsString}}
                    </div>
                </v-col>
                <v-col cols=6>
                    <div>
                        <v-icon small color="primary" class="mr-1">mdi-calendar-range</v-icon>{{courseDate}}
                    </div>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols=6 v-if="staffs">
                    <div>
                        <v-icon small color="primary" class="mr-1">mdi-account-outline</v-icon>
                        <a href v-for="(staff,index) in staffs" :key="staff.id" @click.prevent="doShowStaffInfoDialog(staff)" class="primary--text z-no-underline">{{getName(staff)}}{{index != staffs.length-1 ? ', ' : ''}}</a>
                    </div>
                </v-col>
                <v-col cols=6>
                    <div>
                        <v-icon small color="primary" class="mr-1">mdi-tag-outline</v-icon>{{course.price | price}}
                    </div>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols=6>
                    <div>
                        <v-icon small color="primary" class="mr-1">mdi-folder-multiple-outline</v-icon>{{categoryName}}
                    </div>
                </v-col>
                <v-col cols=6 v-if="sitesAndResourcesText">
                    <div>
                        <v-icon small color="primary" class="mr-1">mdi-map-marker</v-icon>{{sitesAndResourcesText}}
                    </div>
                </v-col>
            </v-row>
        </div>
        <staff-info-dialog v-model="showStaffInfoDialog" :staffId="showStaff.id" v-if="showStaff"/>
    </div>
</template>

<script>
import {getName} from '../util.js'
import BookingStatus from '../components/BookingStatus.vue'
import DialogHeader from '../components/DialogHeader.vue'
import StaffInfoDialog from './StaffInfoDialog.vue'
export default {
    name: 'zoezi-course-header',

    props: {
        course: {},
        showImage: {},
        showTitle: {},
        textClass: {},
        showClose: {}
    },

    components: {
        BookingStatus,
        DialogHeader,
        StaffInfoDialog
    },

    data: () => ({
        showStaffInfoDialog: false,
        showStaff: null
    }),

    computed: {
        staffs() {
            if (!this.course) {
                return null;
            }

            if (this.course.staffs) {
                return this.course.staffs;
            }

            if (this.course.workouts.length == 0) {
                return null;
            }

            let staffs = [];
            this.course.workouts.forEach(w => {
                w.staffs.forEach(s => {
                    if (!staffs.find(x => x.id == s.id)) {
                        staffs.push(s);
                    }
                })
            })

            return staffs;
        },
        resources() {
            if (!this.course) {
                return [];
            }

            if (this.course.resources) {
                return this.course.resources.map(x => x.name);
            }

            let resources = [];
            this.course.workouts.forEach(w => {
                w.resources.forEach(s => {
                    let name = getName(s);
                    if (resources.indexOf(name) == -1) {
                        resources.push(name);
                    }
                })
            })

            return resources;
        },
        category() {
            return this.$store.state.settings?.coursecategories?.find(c => c.id == this.course.category_id);
        },
        image() {
            if (this.course.imagekey) {
                return this.course.imagekey;
            }

            return this.category?.imagekey;
        },
        categoryName() {
            return this.category?.name;
        },
        sites() {
            if (!this.$store.state.settings || !this.$store.state.settings.sites || this.$store.state.settings.sites.length == 1) {
                return [];
            }

            return this.course.sites
                .map(site_id => this.$store.state.settings.sites.find(x => x.id === site_id)?.name)
                .filter(name => typeof name === 'string');
        },
        sitesAndResourcesText() {
            return this.sites.concat(this.resources).join(', ');
        },
        occasionsString() {
            if (this.course.occasions == 1) {
                return this.$translate('1 occasion');
            }
            return this.$translate('{0} occasions').format(this.course.occasions);
        },
        courseDate() {
            if(this.course.startTime.yyyymmdd() === this.course.endTime.yyyymmdd()) {
                return Date.formatTimeFullRelative(this.course.startTime).capitalize() + ' - ' + this.course.endTime.hhmm();
            }
            return Date.formatTimeFullRelative(this.course.startTime).capitalize() + ' - ' + Date.formatTimeFullRelative(this.course.endTime);
        }
    },
    methods: {
        doShowStaffInfoDialog(staff) {
            this.showStaffInfoDialog = true;
            this.showStaff = staff;
        },
        getName: getName
    }
}
</script>
